module.exports = __webpack_public_path__ + "files/SPIADI2019.de39c3835de210d614335687ce2fee67.zip";